import type { Locale } from '../type';

const localeValues: Locale = {
  locale: 'ca',
  Pagination: {
    items_per_page: '/ pàgina',
    jump_to: 'Anar a',
    jump_to_confirm: 'Confirma',
    page: '',
    prev_page: 'Pàgina prèvia',
    next_page: 'Pàgina següent',
    prev_5: '5 pàgines prèvies',
    next_5: '5 pàgines següents',
    prev_3: '3 pàgines prèvies',
    next_3: '3 pàgines següents',
  },
  DatePicker: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent',
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora',
    },
  },
  TimePicker: {
    placeholder: 'Seleccionar hora',
  },
  Calendar: {
    lang: {
      placeholder: 'Seleccionar data',
      rangePlaceholder: [
        'Data inicial',
        'Data final',
      ],
      locale: 'ca_ES',
      today: 'Avui',
      now: 'Ara',
      backToToday: 'Tornar a avui',
      ok: 'Acceptar',
      clear: 'Netejar',
      month: 'Mes',
      year: 'Any',
      timeSelect: 'Seleccionar hora',
      dateSelect: 'Seleccionar data',
      monthSelect: 'Escollir un mes',
      yearSelect: 'Escollir un any',
      decadeSelect: 'Escollir una dècada',
      yearFormat: 'YYYY',
      dateFormat: 'D/M/YYYY',
      dayFormat: 'D',
      dateTimeFormat: 'D/M/YYYY HH:mm:ss',
      monthBeforeYear: true,
      previousMonth: 'Mes anterior (PageUp)',
      nextMonth: 'Mes següent (PageDown)',
      previousYear: 'Any anterior (Control + left)',
      nextYear: 'Mes següent (Control + right)',
      previousDecade: 'Dècada anterior',
      nextDecade: 'Dècada següent',
      previousCentury: 'Segle anterior',
      nextCentury: 'Segle següent',
    },
    timePickerLocale: {
      placeholder: 'Seleccionar hora',
    },
  },
  global: {
    placeholder: 'Seleccionar',
  },
  Table: {
    filterTitle: 'Filtrar el menú',
    filterConfirm: 'D’acord',
    filterReset: 'Reiniciar',
    filterEmptyText: 'Sense filtres',
    selectAll: 'Seleccionar la pàgina actual',
    selectInvert: 'Invertir la selecció',
    selectionAll: 'Seleccionar-ho tot',
    sortTitle: 'Ordenar',
    expand: 'Ampliar la fila',
    collapse: 'Plegar la fila',
    triggerDesc: 'Ordre descendent',
    triggerAsc: 'Ordre ascendent',
    cancelSort: 'Desactivar l’ordre',
  },
  Modal: {
    okText: 'D’acord',
    cancelText: 'Cancel·lar',
    justOkText: 'D’acord',
  },
  Popconfirm: {
    okText: 'D’acord',
    cancelText: 'Cancel·lar',
  },
  Transfer: {
    titles: [
      '',
      '',
    ],
    searchPlaceholder: 'Cercar',
    itemUnit: 'ítem',
    itemsUnit: 'ítems',
    remove: 'Eliminar',
    selectCurrent: 'Seleccionar la pàgina actual',
    removeCurrent: 'Eliminar la selecció',
    selectAll: 'Seleccionar-ho tot',
    removeAll: 'Eliminar-ho tot',
    selectInvert: 'Invertir la selecció',
  },
  Upload: {
    uploading: 'Carregant…',
    removeFile: 'Eliminar el fitxer',
    uploadError: 'Error de càrrega',
    previewFile: 'Vista prèvia del fitxer',
    downloadFile: 'Baixar el fitxer',
  },
  Empty: {
    description: 'Sense dades',
  },
  Icon: {
    icon: 'icona',
  },
  Text: {
    edit: 'Editar',
    copy: 'Copiar',
    copied: 'Copiat',
    expand: 'Ampliar',
  },
  PageHeader: {
    back: 'Enrere',
  },
  Form: {
    optional: '(opcional)',
    defaultValidateMessages: {
      default: 'Error de validació del camp ${label}',
      required: 'Introdueix ${label}',
      enum: '${label} ha de ser un de [${enum}]',
      whitespace: '${label} no pot ser un caràcter en blanc',
      date: {
        format: 'El format de la data de ${label} és invàlid',
        parse: '${label} no es pot convertir a cap data',
        invalid: '${label} és una data invàlida',
      },
      types: {
        string: '${label} no és un ${type} vàlid',
        method: '${label} no és un ${type} vàlid',
        array: '${label} no és un ${type} vàlid',
        object: '${label} no és un ${type} vàlid',
        number: '${label} no és un ${type} vàlid',
        date: '${label} no és un ${type} vàlid',
        boolean: '${label} no és un ${type} vàlid',
        integer: '${label} no és un ${type} vàlid',
        float: '${label} no és un ${type} vàlid',
        regexp: '${label} no és un ${type} vàlid',
        email: '${label} no és un ${type} vàlid',
        url: '${label} no és un ${type} vàlid',
        hex: '${label} no és un ${type} vàlid',
      },
      string: {
        len: '${label} ha de ser de ${len} caràcters',
        min: '${label} ha de tenir com a mínim ${min} caràcters',
        max: '${label} ha de tenir com a màxim ${max} caràcters',
        range: '${label} ha d’estar entre ${min} i ${max} caràcters',
      },
      number: {
        len: '${label} ha de ser igual a ${len}',
        min: '${label} ha de tenir un valor mínim de ${min}',
        max: '${label} ha de tenir un valor màxim de ${max}',
        range: '${label} ha de tenir un valor entre ${min} i ${max}',
      },
      array: {
        len: 'La llargada de ${label} ha de ser de ${len}',
        min: 'La llargada de ${label} ha de ser com a mínim de ${min}',
        max: 'La llargada de ${label} ha de ser com a màxim de ${max}',
        range: 'La llargada de ${label} ha d’estar entre ${min} i ${max}',
      },
      pattern: {
        mismatch: '${label} no coincideix amb el patró ${pattern}',
      },
    },
  },
};

export default localeValues;
